import React from "react";
import "./ShareCard.css";
import checkmark from "../assets/check-mark.png";
import shareimg from "../assets/shareImg1.png";
import { FiArrowUpRight } from "react-icons/fi";

export default function ShareCard() {
  return (
    <div id="sharecard" className="wrapper">
      <div className="container-share">
        <div className="left">
          <h1>Tap & Share Via NFC Cards for Instant Property Access</h1>
          <p>
            Say goodbye to bulky brochures — NFC cards do it all. One tap
            connects clients directly to your listings and contact details.
          </p>
          <ul>
            <li>
              <img src={checkmark} alt="error" />
              <span>Showcase all property listings instantly</span>
            </li>
            <li>
              <img src={checkmark} alt="error" />
              <span>Share a complete digital business profile</span>
            </li>
            <li>
              <img src={checkmark} alt="error" />
              <span>Get appointment bookings with a tap</span>
            </li>
            <li>
              <img src={checkmark} alt="error" />
              <span>Smart, hassle-free networking</span>
            </li>
            <li>
              <img src={checkmark} alt="error" />
              <span>Showcase social media profiles</span>
            </li>
          </ul>
          {/* <div className="btn">
            <button>
              Get Your Own Card <FiArrowUpRight style={{ marginLeft: "8px" }} />
            </button>
          </div> */}
        </div>
        <div className="right">
          <img src={shareimg} alt="error" />
        </div>
      </div>
    </div>
  );
}
